module.exports = __webpack_public_path__ + "img/img_platform_tit.671071eb.svg";